
import Web3SBNPRC20 from '@/abi/Web3SBNPRC20.json'
import SixteenDao from '@/abi/SixteenDao.json';
import { ethers } from "ethers";
import {
    abiAddress,
    SBNAddress,
} from '@/abi/address';
const initWeb3 = (fn) => {
    const initWeb3 = async (...arg) => {
        await initSBNContract();
        await initSixteenDaoContract();
        await connectMetamask();
        if (typeof fn === 'function') {
            return fn(...arg);
        }
    }
    const initSBNContract = async () => {
        if (window.SBNContract) return;
        if (!window.web3) {
            console.error('Web3 is not initialized');
            return;
        }
        try {
            const contract = new window.web3.eth.Contract(Web3SBNPRC20.abi, SBNAddress);
            window.SBNContract = contract;
            console.log('SBN Contract initialized:', contract);
        } catch (error) {
            console.error('Error initializing SBN Contract:', error);
        }
    }
    const initSixteenDaoContract = async () => {
        if (window.SixteenDaoContract || window.contract) return;
        if (!window.web3) {
            console.error('Web3 is not initialized');
            return;
        }
        try {
            const contract = new window.web3.eth.Contract(SixteenDao.abi, abiAddress);
            window.SixteenDaoContract = contract;
            window.contract = contract
            console.log('SixteenDao Contract initialized:', contract);
        } catch (error) {
            console.error('Error initializing SixteenDao Contract:', error);
        }
    }
    const connectMetamask = async () => {
        if (window.provider) return;
        // 1. 用户连接 MetaMask
        window.provider = new ethers.BrowserProvider(window.ethereum);
        window.signer = await window.provider.getSigner(); // 当前连接的钱包地址
        window.token = new ethers.Contract(abiAddress, SixteenDao.abi, window.signer);

    }
    return initWeb3
}
export default initWeb3